<template>
  <div class="fhv-centent" v-loading="loading">
    <h4 class="title-topic">IPv4 WAN Connection Status</h4>

    <el-table
      :data="ip4Data"
      stripe
      style="width: 100%;margin-bottom:50px;"
      border
      class="fhv-table"
    >
      <el-table-column prop="name" label="Connection Name" width="260"></el-table-column>
      <el-table-column prop="type" label="Type"></el-table-column>
      <el-table-column prop="address" label="IP Address" width="260"></el-table-column>
      <el-table-column prop="status" label="Status"></el-table-column>
      <el-table-column label="Method">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row,4)" type="text" size="small">more</el-button>
        </template>
      </el-table-column>
    </el-table>

    <h4 class="title-topic">IPv6 WAN Connection Status</h4>
    <el-table :data="ip6Data" stripe style="width: 100%" border class="fhv-table">
      <el-table-column prop="name" label="Connection Name" width="260"></el-table-column>
      <el-table-column prop="type" label="Type"></el-table-column>
      <el-table-column prop="address" label="IP Address" width="260"></el-table-column>
      <el-table-column prop="status" label="Status"></el-table-column>
      <el-table-column label="Method">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row,6)" type="text" size="small">more</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="name" :visible.sync="dialogFormVisible" :lockScroll="false" width="40%">
      <el-form class="dig" size="mini">
        <el-form-item label="Connection Name:" :label-width="formLabelWidth">
          <p v-text="name"></p>
        </el-form-item>
        <el-form-item label="Type:" :label-width="formLabelWidth">
          <p v-text="type"></p>
        </el-form-item>
        <el-form-item label="IP Address:" :label-width="formLabelWidth">
          <p v-text="ip"></p>
        </el-form-item>
        <el-form-item label="Mask:" :label-width="formLabelWidth" v-if="maskFlag">
          <p v-text="mask"></p>
        </el-form-item>
        <el-form-item label="Default Gateway:" :label-width="formLabelWidth">
          <p v-text="gateway"></p>
        </el-form-item>
        <el-form-item label="Primary DNS:" :label-width="formLabelWidth">
          <p v-text="dns"></p>
        </el-form-item>
        <el-form-item label="Secondary DNS:" :label-width="formLabelWidth">
          <p v-text="sDns"></p>
        </el-form-item>
        <el-form-item label="Prefix:" :label-width="formLabelWidth" v-if="prefixFlag">
          <p v-text="prefix"></p>
        </el-form-item>
        <el-form-item label="Status:" :label-width="formLabelWidth">
          <p v-text="status"></p>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">confirm</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ipv6AddrFormat from '../../util/ipv6AddrFormat'
export default {
  data() {
    return {
      loading: false,
      maskFlag: true,
      prefixFlag: true,
      dialogFormVisible: false,
      name: "hahaha",
      type: "",
      ip: "",
      mask: "",
      gateway: "",
      dns: "",
      sDns: "",
      prefix: "",
      status: "",

      formLabelWidth: "200px",
      ip4Data: [],
      ip6Data: [],
      data: {
        wanipv4: [],
        wanipv6: []
      }
    };
  },
  methods: {
    handleClick(row, ipv) {
      this.showMoreWANinfo(row.index, ipv);
    },
    showMoreWANinfo(index, ipV) {
      if (ipV == 4) {
        this.maskFlag = true;
        this.prefixFlag = false;
        this.name = this.data.wanipv4[index].name;
        this.type = this.data.wanipv4[index].type;
        if (this.data.wanLinkStatus) {
          if (this.data.wanipv4[index].ip != "0.0.0.0")
            this.ip = this.data.wanipv4[index].ip;
          if (this.data.wanipv4[index].maks != "0.0.0.0")
            this.mask = this.data.wanipv4[index].maks;
          if (this.data.wanipv4[index].defaultGateway != "0.0.0.0")
            this.gateway = this.data.wanipv4[index].defaultGateway;
          if (this.data.wanipv4[index].primaryDNS != "0.0.0.0")
            this.dns = this.data.wanipv4[index].primaryDNS;
          if (this.data.wanipv4[index].secondaryDNS != "0.0.0.0")
            this.sDns = this.data.wanipv4[index].secondaryDNS;

          this.status = this.data.wanipv4[index].status;
        } else {
          this.status = "Disconnected";
        }
      } else if (ipV == 6) {
        this.maskFlag = false;
        this.prefixFlag = true;

        this.name = this.data.wanipv6[index].name;
        this.type = this.data.wanipv6[index].type;
        if (this.data.wanLinkStatus) {
          if (this.data.wanipv6[index].ip != "::")
            this.ip = this.data.wanipv6[index].ip;
          if (this.data.wanipv6[index].defaultGateway != "::")
            this.gateway = this.data.wanipv6[index].defaultGateway;
          if (this.data.wanipv6[index].primaryDNS != "::")
            this.dns = this.data.wanipv6[index].primaryDNS;
          if (this.data.wanipv6[index].secondaryDNS != "::")
            this.sDns = this.data.wanipv6[index].secondaryDNS;

          try {
            this.prefix = ipv6AddrFormat.abbreviate(this.data.wanipv6[index].pdAddr);
          } catch (error) {
            console.log(error)
            this.prefix = ""
          }
       
            
          if (
            this.data.wanipv6[index].ip == "::" ||
            this.data.wanipv6[index].ip == ""
          )
            this.status = "Disconnected";
          else this.status = "Connected";
        } else {
          this.status = "Disconnected";
        }
      } else {
        throw new Error("ipV 参数错误！");
        return;
      }
      this.dialogFormVisible = true;
    },
    wanInfo() {
      let _this = this;
      let wanInfo = {
        data: {
          wanipv4: [],
          wanipv6: []
        },
        getData() {
          this.loading = true;
          axios.post("/boafrm/getWANinfo").then(res => {
            this.loading = false;
            if (res.data.ret == "0") {
              wanInfo.data = res.data.wanLists;
              _this.data = res.data.wanLists;
              wanInfo.setDataToHtml();
            } else {
              _this.$message.error(
                `Data acquisition error! Error message:${data.errorMsg}`
              );
            }
          });
        },
        setDataToHtml() {
          let wan4Data = wanInfo.data.wanipv4;
          for (var index = 0; index < wan4Data.length; index++) {
            if (wanInfo.data.wanLinkStatus) {
              var address =
                wan4Data[index].ip == "0.0.0.0" ? "" : wan4Data[index].ip;
              var status = wan4Data[index].status;
            } else {
              var status = "Disconnected";
              var address = "";
            }
            _this.ip4Data.push({
              index: index,
              name: wan4Data[index].name,
              type: wan4Data[index].type,
              address: address,
              status: status
            });
          }
          let wan6Data = wanInfo.data.wanipv6;
          for (var index = 0; index < wan6Data.length; index++) {
            if (wanInfo.data.wanLinkStatus) {
              var address1 =
                wan6Data[index].ip == "::" ? "" : wan6Data[index].ip;

              if (wan6Data[index].ip == "::" || wan6Data[index].ip == "") {
                var status1 = "Disconnected";
              } else {
                var status1 = "Connected";
              }
            } else {
              var status1 = "Disconnected";
              var address1 = "";
            }

            _this.ip6Data.push({
              index: index,
              name: wan6Data[index].name,
              type: wan6Data[index].type,
              address: address1,
              status: status1
            });
          }
        }
      };
      return wanInfo;
    }
  },
  created() {
    this.wanInfo().getData();
  }
};

</script>

<style lang="scss">
.dig {
  .el-form-item {
    margin-bottom: 0px;
    p {
      margin: 0;
    }
  }
}
</style>




